import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input, model } from "@angular/core";

import { HealthStatus } from "../../../apis/stats/rest/models";
import { StatusIcon } from "../../common/status-icon/status-icon.component";
import { ServiceTags } from "../../subscriptions-list/service-tags/service-tags";
import { IotnetMapPopover } from "../iotnet-map-popover/iotnet-map-popover";

interface StatusOption {
  value: HealthStatus;
  labelKey: string;
}

@Component({
  selector: "iotnet-gateway-filter",
  templateUrl: "iotnet-gateway-filter.html",
  styleUrls: ["./iotnet-gateway-filter.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, IotnetMapPopover, ServiceTags, StatusIcon, TranslatePipe],
})
export class IotnetMapFilter {
  public readonly activeStatuses = model<HealthStatus[]>([]);
  public readonly availableTags = input<string[]>([]);
  public readonly activeTags = model<string[]>([]);

  protected readonly options: StatusOption[] = [
    { value: HealthStatus.Ok, labelKey: "Services.Status.Ok" },
    // { value: HealthStatus.Notraffic, labelKey: "Services.Status.NoTraffic" },
    { value: HealthStatus.Malfunction, labelKey: "Services.Status.Warning" },
    { value: HealthStatus.Unknown, labelKey: "Services.Status.Unknown" },
  ];

  protected readonly filtering = computed(() => this.activeStatuses().length > 0 || this.activeTags().length > 0);

  protected isActive(status: HealthStatus): boolean {
    return this.activeStatuses().includes(status);
  }

  protected toggleStatus(status: HealthStatus): void {
    this.activeStatuses.update((active) =>
      active.includes(status) ? active.filter((s) => s !== status) : [...active, status],
    );
  }

  protected toggleTag(tag: string): void {
    this.activeTags.update((active) => (active.includes(tag) ? active.filter((t) => t !== tag) : [...active, tag]));
  }
}
